import { useRef } from "react";
import Button from "@mui/material/Button";
import { parseJsonFile } from "./csv";

export interface ImportJsonButtonProps {
  onImported: (words: Record<string, string>) => void;
  onError?: (error: Error) => void;
}

export function ImportJsonButton({
  onImported,
  onError,
}: ImportJsonButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    inputRef.current?.click();
  };

  const onChange = async () => {
    const file = inputRef.current?.files?.[0];
    if (!file) return;

    try {
      const words = await parseJsonFile(file);
      onImported(words);
    } catch (error) {
      onError?.(error as Error);
    } finally {
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  };

  return (
    <>
      <input
        accept=".json"
        type="file"
        style={{ display: "none" }}
        ref={inputRef}
        onChange={onChange}
      />
      <Button onClick={onClick} color="inherit">
        Import JSON
      </Button>
    </>
  );
}
